import type { ReferentialAxis } from '@/core/domain/referential/axis/ReferentialAxis.ts'
import type { IReferentialRepository } from '@/core/domain/referential/IReferentialRepository.ts'
import type { IReferentialUrlOptions } from '@/core/domain/referential/IReferentialUrlOptions.ts'
import { ReferentialUrlOptions } from '@/core/domain/referential/ReferentialUrlOptions.ts'

export class FetchAllAxisUseCase {
  private referentialRepository: IReferentialRepository

  constructor(referentialRepository: IReferentialRepository) {
    this.referentialRepository = referentialRepository
  }

  async execute(URLOptions?: IReferentialUrlOptions): Promise<ReferentialAxis[]> {
    if (URLOptions) {
      URLOptions = new ReferentialUrlOptions(URLOptions)
    }

    return await this.referentialRepository.fetchAll(URLOptions)
  }
}
